export class UserActivity {
  action: string;
  time: Date;

  getAction(): string {
    return this.action;
  }

  setAction(action: string): UserActivity {
    this.action = action;

    return this;
  }

  getTime(): Date {
    return this.time;
  }

  setTime(time: Date): UserActivity {
    this.time = time;

    return this;
  }
}
